import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-inline: 40px 13px;

  cursor: pointer;
  width: 100%;

  transition: color 0.2s ease-in-out;
  color: ${({ theme }) => theme.colors.AlphaWhite};

  &:hover {
    color: ${({ theme }) => theme.colors.SurfaceWhite};

    & img {
      border-color: ${({ theme }) => theme.colors.SurfaceWhite};
    }
  }

  &.active {
    color: ${({ theme }) => theme.colors.SurfaceWhite};

    & img {
      border-color: ${({ theme }) => theme.colors.SurfaceWhite};
    }
  }
`;

export const Icon = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;

  border: 1px solid ${({ theme }) => theme.colors.WhiteGray};
  border-radius: 4px;

  transition: border-color 0.2s ease-in-out;
`;

export const Name = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 36px;

  gap: 10px;
  user-select: none;

  & > p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    word-break: break-word;
    line-height: unset !important;
  }
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
